export { Badge, badgeSizes } from './Badge';
export type { BadgeProps, BadgeSize } from './Badge';
